export const BeneRelationshipContent = {
  pageTitle1: `How did `,
  pageTitle2: ` list you as a beneficiary?`,
  continueButton: 'Continue',
  accordions: [
    {
      title: `What does 'per stirpes' mean?`,
      text: `Rather than name beneficiaries, the account owner used the "to my descendants who survive me, per stirpes" designation to divide assets equally among their children (but not stepchildren). All children who survive the account owner will share the investments equally. If any of the children die before the account owner, that child's children&mdash;the account owner's grandchildren&mdash;would equally share their deceased parent's share.`,
    },
  ],
  beneRelationshipOptions: [
    {
      key: `DESCENDANT`,
      value: `I'm listed as a descendant, per stirpes`,
    },
    {
      key: `GRANDCHILD`,
      value: `I'm listed as a grandchild`,
    },
    {
      key: `NAMED`,
      value: `I'm listed as a named individual, per stirpes`,
    },
  ],
};
